import { API_ENDPOINT } from '@muzly/shared';

/**
 * 서버를 쓰는 기능(Device Identity·프로필 동기)은 백엔드 주소가 있을 때만 돈다 —
 * prod 가 빈 값이던 기간이 있었고, 그때는 이 라이브러리가 통째로 no-op 이었다.
 *
 * `transport.ts` 와 분리해 둔 이유: 부팅 훅이 lemon-web-core 를 import 하지 않고도
 * 이 판정을 할 수 있어야 한다. 그 모듈은 lazy 로만 로드된다.
 */
export const isApiEnabled = (): boolean => API_ENDPOINT !== '';

/** `muz-d1` base. `/oauth/register-device`·`/profile/0/mine` 이 이 아래에 있다. */
export const getApiEndpoint = (): string => API_ENDPOINT;
